var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cookies-policy",attrs:{"id":"cookies-policy"},domProps:{"innerHTML":_vm._s(_vm.cookies)}})
}
var staticRenderFns = []

export { render, staticRenderFns }